/**
 * Reads a `PUBLIC_`/`VITE_`-prefixed variable from `window.env`. Every
 * environment writes this the same way in spirit, just at different times:
 * fenv.sh injects it at container boot for deployed images (see
 * `frontend/fenv.sh`), rsbuild injects it at dev-server start for `pnpm dev`
 * (see `rsbuild.config.ts`), both sourced from `frontend/.env` locally or
 * from frontend/cloudformation.yml when deployed.
 */
export function readPublicEnv(key: string): string | undefined {
  // Node-side tests import modules that read config at load time; there is no
  // window there, and "not set" is the right answer.
  return typeof window === 'undefined' ? undefined : window.env?.[key];
}

declare global {
  interface Window {
    env?: Record<string, string>;
  }
}
